/* Shared "what changed vs current" delta panel (C2 rates + C3 TAT).
   Mirrors the mockup deltaPanel() — a titled card with a "N changed" info badge
   and a vertical list of delta rows (passed as children). */
import React from 'react'
import PropTypes from 'prop-types'

export default function DeltaPanel({title, count, emptyMsg, children}) {
  return (
    <div className='card card-pad' style={{marginBottom: 16}}>
      <div
        className='row center gap8'
        style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: count ? 10 : 0}}
      >
        <span className='seclabel' style={{margin: 0}}>
          {title}
        </span>
        {count ? <span className='badge b-info'>{count} changed</span> : null}
      </div>
      {count ? (
        <div className='delta-list'>{children}</div>
      ) : (
        <div className='muted' style={{fontSize: 12.5}}>
          {emptyMsg || 'No changes yet.'}
        </div>
      )}
    </div>
  )
}

DeltaPanel.propTypes = {
  title: PropTypes.string,
  count: PropTypes.number,
  emptyMsg: PropTypes.node,
  children: PropTypes.node,
}

/* small vertical chips helper used across the wizard steps */
export function VertChips({verticals = []}) {
  return (
    <>
      {verticals.map((x) => (
        <span key={x} className={'chip chip-' + String(x).toLowerCase()}>
          {x}
        </span>
      ))}
    </>
  )
}

VertChips.propTypes = {
  verticals: PropTypes.array,
}
